import { whenSettled } from '@/src/renderer/lib/motion/whenSettled'

/** Läuft an der Zeile oder einem Vorfahren eine Animation (Einblenden, Hineinfahren)? */
function animating(el: Element): boolean {
  for (let node: Element | null = el; node; node = node.parentElement) {
    // jsdom kennt `getAnimations` nicht — dort zählt allein die Lage.
    if (typeof node.getAnimations !== 'function') return false
    if (node.getAnimations().some(a => a.playState === 'running')) return true
  }
  return false
}

/** Der nächste Vorfahr, der rollt — seine Höhe wächst, solange die Seite nachlädt. */
function scrollerOf(el: Element): Element | null {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node)
    if (overflowY === 'auto' || overflowY === 'scroll') return node
  }
  return null
}

/**
 * Ruft `run` mit der Zeile einer Aufgabe, sobald ihre Seite **fertig geladen** ist (`whenSettled`):
 * Die Zeile steht da, die Höhe der Liste und die Lage der Zeile bleiben einige Bilder lang gleich,
 * und nichts daran fährt noch. Erst dann auswählen und ins Bild rollen — sonst rutscht die Aufgabe
 * wieder weg, während die Seite nachlädt (#210, gemeldet 01.10.2026).
 *
 * `root` ist die Seite: Dieselbe Aufgabe kann in einem anderen, verborgenen Tab stehen.
 */
export function whenTaskRowSettled({ root, taskId, run }: {
  root: () => ParentNode | null
  taskId: string
  run: (row: HTMLElement) => void
}): () => void {
  const selector = `[data-task-id="${CSS.escape(taskId)}"]`
  const find = () => root()?.querySelector<HTMLElement>(selector) ?? null
  let moving = 0
  return whenSettled(
    () => {
      const row = find()
      if (!row) return null
      // Jede Messung anders, solange etwas fährt — so zählt kein Bild als ruhig.
      if (animating(row)) return `moving-${moving++}`
      const rect = row.getBoundingClientRect()
      return `${scrollerOf(row)?.scrollHeight ?? 0}:${Math.round(rect.top)}:${Math.round(rect.height)}`
    },
    () => {
      const row = find()
      if (row) run(row)
    },
  )
}
